import {OrderContext} from "../../context/OrderContext";
import {UserContext} from "../../context/UserContext";
import React, {useContext, useState} from "react";
import {LuTrash} from "react-icons/lu";
import {APICreateOrderTenderBids,  APIDeleteOrderTenderBids, APIGetOrderTenderBidsByCompany, APIUpdateOrderTenderBids} from "../../api/orders/OrdersTender";
import OrderMessaging from "./orderMessaging";
import {FileContext} from "../../context/FileContext";
import OrderUploadBidHandler from "./files/orderUploadCustomFolderHandler";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

export default function OrderAddBid() {

    const {user} = useContext(UserContext);
    const {order,tender} = useContext(OrderContext);
    const orderEdit = true;
    const [bid,setBid] = useState({
        id:null,
        bid:null
    });


    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }
        return true;
    }

    const submitBid = async (type) => {
        if(typeof bid?.id !== "undefined" && bid?.id !== null) {
            await APIUpdateOrderTenderBids(order?.id, bid,tender?.tenderid,type, bid?.id, user);
        } else {
            await APICreateOrderTenderBids(order?.id, bid,tender?.tenderid, type, user).then((response) => setBid(response?.[0]));
        }
    }

    const archiveBid = async () => {
        await APIDeleteOrderTenderBids({orderId: order?.id, tenderId: tender?.tenderid, orderTenderBidsId: bid?.id, companyId: user.companyId}).then((response) => {setBid({
            id:null,
            bid:null
        });})
    }


    if(tender !== null && bid?.id === null) {
        APIGetOrderTenderBidsByCompany(order?.id,tender?.tenderid, user).then(function(result) {
            if(result?.length > 0) {
                setBid(result?.[0]);
            }
        });
    }



    return (
        <div>
            <div className={"border border-gray-500 rounded-lg divide-y bg-white divide-gray-300 overflow-hidden text-left mb-2 sm:mb-4 md:mb-8"}>
                <div className={'lg:p-6 p-4'}>
                    <div className="px-4 sm:px-0 mb-4">
                        <h3 className="font-semibold text-lg text-gray-900">Angebot für Auftrag abgeben</h3>
                    </div>
                    <div>
                        {(tender?.details?.bidProcess === "xplanung24") && (
                            <div>

                                <p className={"text-sm mb-2"}>
                                    Sie haben hier die Möglichkeit, ein Angebot für den Auftrag abzugeben.
                                </p>

                                <b htmlFor="bid" className="block text-gray-900 my-6">
                                    Ihr Netto-Angebot
                                </b>

                                <div className={"flex justify-between  my-6"}>
                                    <TextField
                                        className="  flex-1 w-full border border-gray-300 bg-gray-100 text-white  rounded  placeholder:text-gray-200 focus:ring-0 sm: sm:leading-6"
                                        name={"bid"}
                                        required={true}
                                        type={"number"}
                                        size="small"
                                        onChange={(e) => {
                                            if(e?.target.value > 0 && e?.target.value !== null) {
                                                var newBid = {...bid};
                                                    newBid.bid = e?.target.value;
                                                setBid(newBid);
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">€</InputAdornment>
                                        }}
                                        value={(bid?.bid !== null) ? bid?.bid : 0}
                                    />

                                    {(bid?.bid !== null && bid?.id !== null) ? (
                                        <button onClick={() => { archiveBid()}} type="button"  className="ml-3 inline-flex items-center rounded-md border border-red  px-3 py-2 text-sm font-semibold text-red focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Zurückziehen</button>
                                    ) : (
                                        <button onClick={() => { submitBid("bid");}} type="button"  className="ml-3 inline-flex items-center rounded-md border border-gray-900   px-3 py-2 text-sm font-semibold text-white bg-gray-900">Abgeben</button>)
                                    }

                                </div>

                                <b htmlFor="bid" className="block text-gray-900  mt-6">
                                    Ihre Angebotsunterlagen
                                </b>

                                <div className={"flex  bidUpload "}>
                                    <FileContext.Provider className={"wrapper"} value={{order, orderEdit}}>
                                        <OrderUploadBidHandler data={[{
                                            name: "",
                                            path: order?.createdByCompany+"/orders/"+order?.id.replaceAll("-", '/')+"/bidDocuments/"+user?.companyId,
                                            orderEdit: true,
                                            fileType: 'PDF'
                                        }]}/>
                                    </FileContext.Provider>
                                </div>

                                {(typeof order?.planDetails?.deadline !== "undefined"  && isEmpty(order?.planDetails?.deadline) !== true) ? (
                                    <div className={"pt-6 text-sm"}>
                                        <b className={"text-red "}>Achtung</b>
                                        <p className={"text-red "}>Abgabeleisung muss bis zum  <b>{order?.planDetails?.deadline?.date}</b> erfolgen.</p>
                                    </div>
                                ): ("")}


                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div>
                <div className={"border border-gray-500 rounded-lg divide-y bg-white divide-gray-300 overflow-hidden text-left pt-6 mb-2 sm:mb-4 md:mb-8"}>
                     <OrderMessaging data={{"title":"Rückfragen zur Vergabe (Öffentlich)", "linkType":"tenderMessage", "linkId": order?.id, "orderId":order?.id,"type": "all", "stage": order?.stage }}/>
                </div>
            </div>
        </div>



    );

}
